<a
  href="#" 
  class="link-text underline text-[1.4rem]"
  (click)="onProcessAction($event); $event.preventDefault()"
  data-testid="action-link"
  [class]="componentConfig?.readonly ? 'read-only' : ''"
  >{{ componentData }}</a
>
